module.exports = __webpack_public_path__ + "img/2023112315205443233t.5f31cb26.jpg";